import classNames from 'classnames'
import { PropsWithChildren } from 'react'
import Link, { LinkProps } from 'next/link'
import styles from './Button.module.scss'
import useQHref from 'utils/hooks/useQHref'

export interface ButtonProps {
  variant?: 'default' | 'circuit'
  className?: string
  id?: string
  href?: LinkProps['href']
  as?: LinkProps['as']
  onClick?: () => void
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
}

const Button = (props: PropsWithChildren<ButtonProps>) => {
  const { children, variant = 'default', className, id, href, as, onClick, type, ...rest } = props

  const buttonClassName = classNames(className, styles.button, styles[variant])
  const { buildHref } = useQHref()
  const finalHref = href ? buildHref(href) : undefined

  return (
    <>
      {href ? (
        <Link
          className={buttonClassName}
          onClick={onClick}
          id={id}
          href={finalHref}
          as={as}
          {...rest}
        >
          {children}
        </Link>
      ) : (
        <button onClick={onClick} className={buttonClassName} id={id} type={type} {...rest}>
          {children}
        </button>
      )}
    </>
  )
}

export default Button
